import { createSelectors as a } from "@waitroom/state";
import { create as s } from "zustand";
const r = s()(
  () => ({
    modal: void 0
  })
), o = a(r), l = (t) => {
  o.setState(
    (e) => ({
      ...e,
      ...t
    })
  );
}, m = (t) => {
  o.setState(
    (e) => ({
      ...e,
      modal: t
    })
  );
};
export {
  m as setModal,
  l as updateModal,
  o as useModal
};
